// extracted by mini-css-extract-plugin
module.exports = {"Certificates":"Certificates_Certificates__34NJN","BudgeContainer":"Certificates_BudgeContainer__2uGx9","LabelText":"Certificates_LabelText__2P0v8"};